import axios from 'axios';
import { Token } from './token';
import Config from '@/config';

const baseUrl = `${Config.BaseAPI}/v3/subscription`;

export default {
  getSubscriptionByUserId: async function(userId) {
    const url = `${baseUrl}?userId=${userId}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    const result = await axios.get(url, { headers });
    return result.data.record;
  },

  getSubscriptionByUsers: async function(users) {
    const url = `${baseUrl}s`;
    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    const result = await axios.post(
      url,
      {
        userId: users
      },
      { headers }
    );
    return result.data.record;
  }
};
